import React, { useState } from 'react';
import { X } from 'lucide-react';
import { PageHero } from './AboutPage';

const images = [
  'https://images.pexels.com/photos/9799743/pexels-photo-9799743.jpeg',
  'https://images.pexels.com/photos/32543708/pexels-photo-32543708.jpeg',
  'https://images.pexels.com/photos/414905/pexels-photo-414905.jpeg',
  'https://images.pexels.com/photos/32408717/pexels-photo-32408717.jpeg',
  'https://images.pexels.com/photos/37061433/pexels-photo-37061433.jpeg',
  'https://images.pexels.com/photos/27637329/pexels-photo-27637329.jpeg',
  'https://images.pexels.com/photos/27863809/pexels-photo-27863809.jpeg',
  'https://images.pexels.com/photos/24376862/pexels-photo-24376862.jpeg',
  'https://images.unsplash.com/photo-1593941707874-ef25b8b4a92b',
  'https://images.unsplash.com/photo-1593941707882-a5bba14938c7',
];

const categories = ['All', 'CBG Plants', 'Solar', 'EV Charging', 'Bio-Fuel'];

const GalleryPage = () => {
  const [active, setActive] = useState('All');
  const [open, setOpen] = useState(null);

  return (
    <div>
      <PageHero title="Our Gallery" subtitle="A visual journey through our plants, projects and people." />
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap items-center justify-center gap-3">
            {categories.map((c) => (
              <button key={c} onClick={() => setActive(c)}
                      className={`px-5 py-2.5 rounded-full text-sm font-semibold transition-colors ${active === c ? 'bg-emerald-500 text-white shadow-md shadow-emerald-200' : 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100'}`}>{c}</button>
            ))}
          </div>

          <div className="mt-12 columns-1 sm:columns-2 lg:columns-3 gap-5">
            {images.map((img, i) => (
              <button key={i} onClick={() => setOpen(img)} className="mb-5 block w-full overflow-hidden rounded-2xl group relative">
                <img src={img} alt={`Gallery ${i+1}`} className="w-full h-auto group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0b1a1a]/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              </button>
            ))}
          </div>
        </div>
      </section>

      {open && (
        <div className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm grid place-items-center p-6" onClick={() => setOpen(null)}>
          <button className="absolute top-6 right-6 w-11 h-11 rounded-full bg-white grid place-items-center" onClick={() => setOpen(null)}>
            <X className="w-5 h-5" />
          </button>
          <img src={open} alt="preview" className="max-w-5xl max-h-[85vh] rounded-2xl shadow-2xl" />
        </div>
      )}
    </div>
  );
};

export default GalleryPage;
